// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participants-wrap {
  height: auto;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
.participants-wrap h4 {
  height: 10px;
  line-height: 10px;
  font-weight: bold;
}
.participants-wrap .participant-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 7px;
  margin-bottom: 10px;
}
.participants-wrap .participant-info {
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.participants-wrap .participant-avatar {
  width: 50px;
  height: 50px;
  padding: 10px;
  background-color: #1890ff;
  vertical-align: middle;
  font-size: 20px;
  margin-right: 5px;
}
.participants-wrap .participant-actions {
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: start;
  cursor: pointer;
}
.participants-wrap .chat-message-wrap {
  flex-grow: 1;
  overflow-y: auto;
  border-bottom: 1px solid #eee;
}
.participants-wrap .chat-message-box {
  height: 70px;
  box-sizing: border-box;
  padding: 0 5px;
}
.participants-wrap .chat-message-box > textarea {
  padding: 5px 20px;
  height: 100%;
  width: 100%;
  resize: none;
}
.participants-wrap .chat-disabled {
  height: 155px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  flex-shrink: 0;
}

.ant-modal-content,
.ant-modal-header {
  border-radius: 10px;
}

.ant-modal-title {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/components/participants.scss"],"names":[],"mappings":"AAAA;EAGE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAIA,eAAA;AAJF;AAKE;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;AAHJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAHJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAME;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAJJ;AAME;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AAJJ;AAME;EACE,YAAA;EACA,sBAAA;EACA,cAAA;AAJJ;AAKI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAHN;AAME;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAJJ;;AAQA;;EAEE,mBAAA;AALF;;AAQA;EACE,eAAA;AALF","sourcesContent":[".participants-wrap {\n  // width: 60vw;\n  // max-width: 800px;\n  height: auto;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  // border-radius: 16px;\n  // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);\n  // box-sizing: border-box;\n  padding: 10px 0;\n  h4 {\n    height: 10px;\n    line-height: 10px;\n    font-weight: bold;\n  }\n  .participant-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 7px;\n    margin-bottom: 10px;\n  }\n  .participant-info {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    // margin: 5px;\n  }\n  .participant-avatar {\n    width: 50px;\n    height: 50px;\n    padding: 10px;\n    background-color: #1890ff;\n    vertical-align: middle;\n    font-size: 20px;\n    margin-right: 5px;\n  }\n  .participant-actions {\n    align-self: center;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    cursor: pointer;\n  }\n  .chat-message-wrap {\n    flex-grow: 1;\n    overflow-y: auto;\n    border-bottom: 1px solid #eee;\n  }\n  .chat-message-box {\n    height: 70px;\n    box-sizing: border-box;\n    padding: 0 5px;\n    > textarea {\n      padding: 5px 20px;\n      height: 100%;\n      width: 100%;\n      resize: none;\n    }\n  }\n  .chat-disabled {\n    height: 155px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    flex-shrink: 0;\n  }\n}\n\n.ant-modal-content,\n.ant-modal-header {\n  border-radius: 10px;\n}\n\n.ant-modal-title {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
